import * as React from "react";
import { Segment, Icon, Image } from "semantic-ui-react";
import { useTranslation } from "react-i18next";

import Typography from "../../atoms/Typography/Typography";
import { definedTypographyTypes } from "../../atoms/Typography/TypographyStyles";
import SimpleButton, {
  definedButtonTypes,
} from "../../atoms/Buttons/SimpleButton/SimpleButton";
import { styledWithTheme } from "../../../styles/theme";
import { STORM_ICON } from "../../../images/imageSources";

export interface ErrorBannerProps {
  refresh?: () => void;
  main?: boolean;
}

const StyledSegment = styledWithTheme(Segment)<{ margin: 0 | 1 }>(
  ({ margin, theme }) => ({
    "&&&": {
      backgroundColor: theme.palette.mono.lightest,
      textAlign: "center",
      padding: "50px 0",
      border: "none",
      boxShadow: "none",
      borderRadius: 0,
      ".button": {
        marginTop: "1em",
      },
      ...(margin
        ? {
            margin: "10vh",

            "@media only screen and (max-width: 700px)": {
              margin: "5vh",
            },
            "@media only screen and (max-width:600px)": {
              margin: "10px",
            },
          }
        : { margin: 0 }),
    },
  }),
);

const ErrorBanner: React.FC<ErrorBannerProps> = ({ refresh, main }) => {
  const { t } = useTranslation();
  const windowReload = () => window.location.reload();
  return (
    <StyledSegment margin={main ? 1 : 0}>
      <Image
        src={STORM_ICON}
        width={180}
        verticalAlign="middle"
        alt="storm icon"
      />
      <Typography type={definedTypographyTypes.h1} align="center">
        {t("InfoBanners.SomethingWentWrong")}
      </Typography>
      <Typography type={definedTypographyTypes.body1} align="center">
        {t("InfoBanners.CheckYourInternet")}
      </Typography>
      <SimpleButton
        id="refreshOnErrorButton"
        onClick={refresh || windowReload}
        variant={definedButtonTypes.action}
      >
        <Icon name="refresh" />
        {t("InfoBanners.Refresh")}
      </SimpleButton>
    </StyledSegment>
  );
};

export default ErrorBanner;
